import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ShipmentToolbar from './toolbar/shipment-toolbar';
import ShipmentTabs from './tabs/shipment-tabs';
import { useShipmentTabParam } from './useShipmentTabParam';
import { useShipmentsDateFilterParam } from './useShipmentsDateFilterParam';
import { IDateRangeFilterValue } from '../../common/date-range-filter/date-range-filter.interface';
import { shipmentDetails, shipmentManagement } from '../../common/constants/url-constants';
import { useI18nState } from '../../stores/settings/language-context';
import './shipments-page.scss';

const initialDateFilter: IDateRangeFilterValue = {
  fromDate: new Date(),
  toDate: new Date(),
  dateFilterType: 1
};

export default function ShipmentsPage() {
  const navigate = useNavigate();
  const { localeData } = useI18nState();
  const { activeTab, setActiveTab } = useShipmentTabParam();
  const dateFilterParam = useShipmentsDateFilterParam();
  const [searchText, setSearchText] = useState('');
  const [dateFilter, setDateFilter] = useState<IDateRangeFilterValue>(
    dateFilterParam ?? initialDateFilter
  );

  const handleShipmentIdClick = (shipment: { shipmentNumber: string }) => {
    const path = shipmentDetails.replace(
      ':shipmentNumber',
      shipment.shipmentNumber
    );
    navigate(path, {
      state: {
        breadCrumbLinks: [
          { title: localeData.Shipments, path: shipmentManagement },
          { title: shipment.shipmentNumber }
        ]
      }
    });
  };

  return (
    <div className="shipments-page" data-testid="shipments_page">
      <ShipmentToolbar
        searchText={searchText}
        onSearchTextChange={setSearchText}
        dateFilter={dateFilter}
        onDateFilterChange={setDateFilter}
      />

      <div className="shipments-content-area">
        <ShipmentTabs
          activeTab={activeTab}
          onTabChange={setActiveTab}
          searchText={searchText}
          dateFilter={dateFilter}
          onShipmentIdClick={handleShipmentIdClick}
        />
      </div>
    </div>
  );
}
